import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { components } from '@atlaskit/select';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N200 } from '@atlaskit/theme/colors';
var spacing = 8;
var fontSize = 12;
var innerHeight = spacing * 2; // 16px
var lineHeight = innerHeight / fontSize;
var controlWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  padding: "0px ".concat("var(--ds-space-100, 8px)", " ", "var(--ds-space-100, 8px)")
});
var getLabelStyle = function getLabelStyle() {
  return css({
    color: "var(--ds-text-subtlest, ".concat(N200, ")"),
    fontSize: "".concat(fontSize, "px"),
    fontWeight: 600,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: "".concat(lineHeight),
    paddingBottom: "var(--ds-space-050, 4px)",
    paddingLeft: "var(--ds-space-0, 0px)",
    paddingRight: "var(--ds-space-0, 0px)",
    paddingTop: "var(--ds-space-250, 20px)"
  });
};
export var PopupControl = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PopupControl, _React$PureComponent);
  var _super = _createSuper(PopupControl);
  function PopupControl() {
    _classCallCheck(this, PopupControl);
    return _super.apply(this, arguments);
  }
  _createClass(PopupControl, [{
    key: "render",
    value: function render() {
      var popupTitle = this.props.selectProps.popupTitle;
      return jsx("div", {
        css: controlWrapper
      }, jsx("div", {
        css: getLabelStyle()
      }, popupTitle), jsx(components.Control, this.props));
    }
  }]);
  return PopupControl;
}(React.PureComponent);